class GdprMobileFilters {
    constructor() {
        this.filtersButton = document.querySelector('.blog-archive__gdpr-table-filters--button');
        this.filtersClose = document.querySelector('.blog-archive__gdpr-table-filters--close');
        this.filtersBox = document.querySelector('.blog-archive__gdpr-table-filters--hidden');
        this.filtersHeading = document.querySelector('.blog-archive__gdpr-table-filters--heading');
        this.tableHeadline = document.querySelector('.blog-archive__gdpr-table-headline');

        if(this.filtersButton && this.filtersBox && this.filtersHeading && this.filtersClose && this.tableHeadline) {
            this.events();
        }
    }

    events() {
        this.filtersButton.addEventListener('click', () => {
            this.openFilters();
        });
        this.filtersClose.addEventListener('click', () => {
            this.closeFilters();
        });

        // if(window.innerWidth < 1024) {
        //     window.addEventListener('scroll', () => {
        //         console.log(window.scrollY);
        //         if(window.scrollY > 460) {
        //             this.closeFilters();
        //         }
        //     });
        // };

    }

    closeFilters() {
        this.filtersBox.classList.remove('expand');
        this.filtersButton.classList.remove('hidden');
        this.filtersHeading.classList.remove('expand');
        this.tableHeadline.classList.remove('filters-opened');
        this.filtersClose.classList.add('hidden');
    }

    openFilters() {
        this.filtersBox.classList.add('expand');
        this.filtersButton.classList.add('hidden');
        this.filtersHeading.classList.add('expand');
        this.tableHeadline.classList.add('filters-opened');
        this.filtersClose.classList.remove('hidden');
    }


}

export default GdprMobileFilters;
